const contentstack = require('contentstack');

export const getStack = (hash) => {
  const Stack = contentstack.Stack({
    api_key: process.env.NEXT_PUBLIC_CS_DELIVERY_API_KEY,
    delivery_token: process.env.NEXT_PUBLIC_CS_DELIVERY_TOKEN,
    environment: process.env.NEXT_PUBLIC_CS_ENVIRONMENT,
    live_preview: {
      enable: process.env.NEXT_PUBLIC_CS_LIVE_PREVIEW === 'true',
      preview_token: process.env.CS_LIVE_PREVIEW_TOKEN,
      host: 'rest-preview.contentstack.com'
    },
    fetchOptions: {
      timeout: 4000,
      retryLimit: 1,
      retryDelay: 300,
      retryCondition: (error) => {
        const status = error?.status || error?.response?.status;
        const shouldRetry = [502, 414, 429].includes(status);

        console.info('Contentstack API request failed:', {
          status,
          shouldRetry
        });

        return shouldRetry;
      }
    },
    branch: 'main'
  });

  if (hash) {
    Stack.livePreviewQuery({ live_preview: hash });
  }

  return Stack;
};
